export default "__VITE_ASSET__B7WEF$yi__"